module.exports = __webpack_public_path__ + "static/Reliable-aea732f9e121e8b13376ef8aaae0dcbf.svg";